import { useForm, Controller } from "react-hook-form";
import { Box, TextField, Button, Typography } from "@mui/material";
import { updatePassword } from "../utils/api";

const ProductForm = ({
  user,
  done,
  setSnackbarMessage,
  setSnackbarSeverity,
  handleOpenSnackbar,
}) => {
  const { handleSubmit, control, watch, reset } = useForm();

  const password1 = watch("password", "");

  const onSubmit = async (data) => {
    try {
      data.user = user._id;
      const response = await updatePassword(data);
      if (response.status === 200) {
        setSnackbarMessage(response.data.message || "Successful");
        setSnackbarSeverity("success");
        handleOpenSnackbar();
        reset();
        done();
      } else {
        setSnackbarMessage(response.data.message || "Failed");
        setSnackbarSeverity("error");
        handleOpenSnackbar();
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(
        error?.response?.data?.message ||
          "An error occurred. Please try again later."
      );
      setSnackbarSeverity("error");
      handleOpenSnackbar();
    }
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxWidth: 400,
          margin: "0 auto",
        }}
      >
        <Typography variant="caption">
          This will reflect on the next login.
        </Typography>
        <Controller
          name="password"
          control={control}
          defaultValue=""
          rules={{ required: "Password is required" }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
        />
        <Controller
          name="confirmPassword"
          control={control}
          defaultValue=""
          rules={{
            required: "Confirm password is required",
            validate: (value) =>
              value === password1 || "Passwords do not match",
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Confirm Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              sx={{ marginBottom: 2 }}
            />
          )}
        />
        <Box textAlign="right">
          <Button type="submit" variant="contained" color="primary">
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ProductForm;
